import { useContext } from "react";
import { SideBarAuthContext } from "@/context/SideBarAuthModal";

export const useSideBarAuthModal = () => {
  return useContext(SideBarAuthContext);
};